import api from "api";
import { Moment } from "moment";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { FollowerType } from "types";
import "./performance-measurement.scss";
import Summary from "./summary";
import WeeklyInsights from "./weekly-insights";
import FollowerPie from "./follower-pie";
import FollowerMatrix from "./follower-matrix";

interface props {
    projectId: number;
    dateFrom: Moment;
    dateTo: Moment;
    streamIds: number[];
}

function PerformanceMeasurement({ projectId, dateFrom, dateTo, streamIds }: props) {
    const [followers, setFollowers] = useState<FollowerType[]>([]);
    dateFrom = moment().subtract(8, "w");

    const getFollowers = useCallback(async () => {
        const data = await api.profile.get(projectId, dateFrom, dateTo, streamIds);
        setFollowers(data);
    }, [projectId, dateTo, streamIds]);

    useEffect(() => {
        getFollowers();
    }, [projectId, dateTo, streamIds]);

    return (
        <div className="performance-measurement-components">
            {/*<Summary data={followers} streamIds={streamIds}/>*/}
            <WeeklyInsights data={followers} streamIds={streamIds} dateFrom={dateFrom} dateTo={dateTo} />
            <FollowerPie data={followers} streamIds={streamIds} />
            <FollowerMatrix data={followers} streamIds={streamIds} dateFrom={dateFrom} dateTo={dateTo} />
        </div>
    );
}

export default PerformanceMeasurement;
